var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "split-pane",
      class: _vm.classes,
      on: {
        mousemove: _vm.dragMove,
        mouseup: _vm.dragEnd,
        mouseleave: _vm.dragEnd
      }
    },
    [
      _c(
        "div",
        { staticClass: "left top", style: _vm.leftStyles },
        [
          _vm._t("left"),
          _c("div", {
            staticClass: "dragger",
            on: {
              mousedown: function($event) {
                $event.preventDefault()
                return _vm.dragStart($event)
              }
            }
          })
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "right bottom", style: _vm.rightStyles },
        [_vm._t("right")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }